import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { Trans } from 'react-i18next';

class Sidebar extends Component {

  state = {};

  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({[menuState] : false});
    } else if(Object.keys(this.state).length === 0) {
      this.setState({[menuState] : true});
    } else {
      Object.keys(this.state).forEach(i => {
        this.setState({[i]: false});
      });
      this.setState({[menuState] : true}); 
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    document.querySelector('#sidebar').classList.remove('active');
    Object.keys(this.state).forEach(i => {
      this.setState({[i]: false});
    });

    const dropdownPaths = [
      {path:'/apps', state: 'appsMenuOpen'},
      {path:'/basic-ui', state: 'basicUiMenuOpen'},
      {path:'/form-elements', state: 'formElementsMenuOpen'},
      {path:'/tables', state: 'tablesMenuOpen'},
      {path:'/icons', state: 'iconsMenuOpen'},
      {path:'/charts', state: 'chartsMenuOpen'},
      {path:'/user-pages', state: 'userPagesMenuOpen'},
      {path:'/error-pages', state: 'errorPagesMenuOpen'},
    ];

    dropdownPaths.forEach((obj => {
      if (this.isPathActive(obj.path)) {
        this.setState({[obj.state] : true})
      }
    }));
 
  }

  render () {
    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
          <a className="sidebar-brand brand-logo" href="index.html"><img src={require('../../assets/images/bannerlogo.png')} alt="logo" /></a>
          <a className="sidebar-brand brand-logo-mini" href="index.html"><img src={require('../../assets/images/favicon.png')} alt="logo" /></a>
        </div>
        <ul className="nav">
       
          <li className="nav-item nav-category">
            <span className="nav-link"><Trans>Navigation</Trans></span>
          </li>
          <li className={ this.isPathActive('/dashboard') ? 'nav-item menu-items active' : 'nav-item menu-items' }>
            <Link className="nav-link" to="/dashboard">
              <span className="menu-icon"><i className="mdi mdi-speedometer"></i></span>
              <span className="menu-title"><Trans>Dashboard</Trans></span>
            </Link>
          </li>
         
          
          <li className={ this.isPathActive('/tables') ? 'nav-item menu-items active' : 'nav-item menu-items' }>
            <div className={ this.state.tablesMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } onClick={ () => this.toggleMenuState('tablesMenuOpen') } data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-table-large"></i>
              </span>
              <span className="menu-title"><Trans>Tables</Trans></span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={true}>
              <div>
                <ul className="nav flex-column sub-menu">
                 
                  <li className="nav-item"> <Link className={ this.isPathActive('/currencylist') ? 'nav-link active' : 'nav-link' } to="/currencylist"><Trans>Currency List</Trans></Link></li>
                   <li className="nav-item"> <Link className={ this.isPathActive('/cmsandfaq') ? 'nav-link active' : 'nav-link' } to="/cmsandfaq"><Trans>Cms List</Trans></Link></li>
                  <li className="nav-item"> <Link className={ this.isPathActive('/sociallist') ? 'nav-link active' : 'nav-link' } to="/sociallist"><Trans>Social List</Trans></Link></li>
                  <li className="nav-item"> <Link className={ this.isPathActive('/userlist') ? 'nav-link active' : 'nav-link' } to="/userlist"><Trans>User List</Trans></Link></li>
                  <li className="nav-item"> <Link className={ this.isPathActive('/faqlist') ? 'nav-link active' : 'nav-link' } to="/faqlist"><Trans>FAQ List</Trans></Link></li>
                  <li className="nav-item"> <Link className={ this.isPathActive('/tokenlist') ? 'nav-link active' : 'nav-link' } to="/tokenlist"><Trans>NFT Card List</Trans></Link></li>
                  <li className="nav-item"> <Link className={ this.isPathActive('/roadmaplist') ? 'nav-link active' : 'nav-link' } to="/roadmaplist"><Trans>Savage RoadMap</Trans></Link></li>
                  <li className="nav-item"> <Link className={ this.isPathActive('/setting') ? 'nav-link active' : 'nav-link' } to="/setting"><Trans>Setting</Trans></Link></li>
                  
                </ul>
              </div>
            </Collapse>
          </li>
          
         
        
          
        </ul>
      </nav>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

  componentDidMount() {
    this.onRouteChanged();
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector('body');
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
      
      el.addEventListener('mouseover', function() {
        if(body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function() {
        if(body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }

}

export default withRouter(Sidebar);


